export const BLE_UUIDS = {
  SERVICE: 0xFFF0,
  TX_NOTIFY: 0xFFF1,
  RX_WRITE: 0xFFF2,
  SERVICE_STR: '0000fff0-0000-1000-8000-00805f9b34fb',
  TX_NOTIFY_STR: '0000fff1-0000-1000-8000-00805f9b34fb',
  RX_WRITE_STR: '0000fff2-0000-1000-8000-00805f9b34fb'
} as const;

export interface DeviceTelemetry {
  model: 'FP102' | 'FV801' | 'UNKNOWN';
  deviceName: string;
  serialNumber: string;
  firmwareVersion: string;
  batteryPercent?: number;
  batteryVoltage?: number;
  rssi?: number;
  countingMode?: string;
  serverHost?: string;
  serverPort?: number;
  serverApi?: string;
  apn?: string;
  apnUser?: string;
  apnPass?: string;
  imei?: string;
  simId?: string;
  simInserted?: boolean;
  netConnected?: boolean;
  serverStatus?: 'onLine' | 'offLine' | 'error' | string;
  deviceTime?: string;
  storageCycleMin?: number;
  uploadCycleMin?: number;
  workingSlot?: string;
  direction?: string;
  countInterval?: number;
  inCount?: number;
  outCount?: number;
  totalCount?: number;
  isConnected: boolean;
}

export type DfuStage =
  | 'IDLE'
  | 'VALIDATING_BIN'
  | 'CONNECTING'
  | 'HANDSHAKE'
  | 'ERASING'
  | 'STREAMING'
  | 'FINALIZING'
  | 'REBOOTING'
  | 'COMPLETED'
  | 'ERROR';

export interface DfuProgress {
  stage: DfuStage;
  percent: number;
  bytesSent: number;
  totalBytes: number;
  speedBps: number;
  etaSeconds: number;
  message: string;
  error?: string;
}

export interface BinaryHeaderInfo {
  valid: boolean;
  modelDetected: 'FP102' | 'FV801' | 'UNKNOWN';
  initialSP: number;
  resetHandler: number;
  sizeBytes: number;
  versionGuess?: string;
  error?: string;
}

export interface ServerConfig {
  addr: string;
  port: number;
  api: string;
}

export interface ApnConfig {
  apn: string;
  apnN?: string;
  apnP?: string;
}
